import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Platform, Canvas } from '@brandwatch/axiom-components';

import InfoConsole from '../containers/InfoConsole/InfoConsole';
import { loadTheme } from '../loadTheme';

import {deviceType} from '../DeviceTypeContext.jsx';
import { InteractiveComponentContext } from '../context';

import './ViziaPlatform.css';
import FullscreenPanel from './FullscreenPanel.jsx';

const ViziaPlatform = ({
  isConsoleOpen,
  toggleInfoConsole,
  showDialogBackground,
  isFullscreenDialogOpen,
  closeFullscreenDialog,
  fullscreenProps,
  options,
  children
}) => {
  const state = useState(null);
  useLayoutEffect(() => {
    if (options) {
      loadTheme(options);
    }
  }, [options && options.themeId]);

  const classes = classnames('vc-text', {
    'mobile': deviceType.isMobile,
    'swipe': deviceType.isDesktop,
    'vc-bg': !showDialogBackground,
    'vc-bg--error': showDialogBackground
  });
  return (
    <div className={classes}>
      <Platform
        openConsolePosition={isConsoleOpen ? 'right' : null}
        openConsoleWidth="0"
        onConsoleClose={toggleInfoConsole}
      >
        <InteractiveComponentContext.Provider value={state}>
          <InfoConsole timeZone={options && options.timezone} />
          <FullscreenPanel
            isOpen={isFullscreenDialogOpen}
            onRequestClose={closeFullscreenDialog}
            panelProps={fullscreenProps}
          />
          <Canvas>{children}</Canvas>
        </InteractiveComponentContext.Provider>
      </Platform>
    </div>
  );
};

ViziaPlatform.propTypes = {
  children: PropTypes.node,
  options: PropTypes.object,
  isConsoleOpen: PropTypes.bool.isRequired,
  toggleInfoConsole: PropTypes.func.isRequired,
  closeFullscreenDialog: PropTypes.func.isRequired,
  showDialogBackground: PropTypes.bool.isRequired,
  isFullscreenDialogOpen: PropTypes.bool.isRequired,
  fullscreenProps: PropTypes.object
};

export default ViziaPlatform;
